module.exports = __webpack_public_path__ + "static/img/11.bd9b279.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/11.png
// module id = ewQP
// module chunks = 0